export default function getItemBeforeAfter(beforeOrAfter, items, index) {
  if (beforeOrAfter === 'before') {
    if (index > 0) {
      if (items[index - 1].itemId) {
        return items[index - 1].itemId
      } else if (items[index - 1].id) {
        return items[index - 1].id
      } else {
        return ''
      }
    }
  } else if (beforeOrAfter === 'after') {
    if (index < items.length - 1) {
      if (items[index + 1].itemId) {
        return items[index + 1].itemId
      } else if (items[index + 1].id) {
        return items[index + 1].id
      } else {
        return ''
      }
    }
  } else {
    return null
  }
}


// WEBPACK FOOTER //
// ./src/helpers/content/manageSets/getItemBeforeAfter.js